import { render } from "./TiposOleo.vue?vue&type=template&id=08f5afb8&scoped=true"
import script from "./TiposOleo.vue?vue&type=script&lang=js"
export * from "./TiposOleo.vue?vue&type=script&lang=js"

import "./TiposOleo.vue?vue&type=style&index=0&id=08f5afb8&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f5afb8"]])

export default __exports__